import React from "react";
import { Box, Button } from "@mui/material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";

// ステッパー下部のナビゲーション（前へ / 保存 / 次へ）
export default function StepperNavigation({
  activeStep,
  stepsLength,
  onBack,
  onNext,
  onSave,
  saving,
  showBack = true,
  showNext = true,
}) {
  const isFirstStep = activeStep === 0;
  const isLastStep = activeStep === stepsLength - 1;

  const canBack = showBack && !isFirstStep;
  const canNext = showNext && !isLastStep;

  const saveLabel = isLastStep ? "保存" : "一時保存";

  // 共通スタイル
  const styles = {
    container: {
      pt: 3,
      mt: 3,
      borderTop: "1px solid #e2e8f0",
    },
    back: {
      bgcolor: "#dc2626",
      color: "white",
      fontWeight: "bold",
      "&:hover": { bgcolor: "#b91c1c" },
      "&.Mui-disabled": { bgcolor: "#d1d5db", color: "#9ca3af" },
    },
    next: {
      bgcolor: "#4F46E5",
      fontWeight: "bold",
      "&:hover": { bgcolor: "#4338CA" },
      "&.Mui-disabled": { bgcolor: "#d1d5db", color: "#9ca3af" },
    },
    save: {
      bgcolor: "#6b7280",
      color: "white",
      fontWeight: "bold",
      "&:hover": { bgcolor: "#4b5563" },
      // 保存中でもスマホ/PCで文字色が黒くならないように統一
      "&.Mui-disabled": { bgcolor: "#d1d5db", color: "#9ca3af" },
    },
  };

  const SaveButton = (props) => (
    <Button
      variant="contained"
      startIcon={<BookmarkBorderIcon />}
      onClick={onSave}
      disabled={saving}
      sx={styles.save}
      {...props}
    >
      {saving ? "保存中..." : saveLabel}
    </Button>
  );

  const BackButton = (props) => (
    <Button
      variant="contained"
      onClick={onBack}
      disabled={!canBack || saving}
      sx={styles.back}
      {...props}
    >
      前へ
    </Button>
  );

  const NextButton = (props) => (
    <Button
      variant="contained"
      onClick={onNext}
      disabled={!canNext || saving}
      sx={styles.next}
      {...props}
    >
      次へ
    </Button>
  );

  return (
    <Box sx={styles.container}>
      {/* スマホ：保存を全幅、下に前へ/次へ */}
      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        <SaveButton fullWidth sx={{ ...styles.save, py: 1.5 }} />

        <Box sx={{ display: "flex", gap: 1, mt: 1.25 }}>
          <BackButton fullWidth />
          <NextButton fullWidth />
        </Box>
      </Box>

      {/* PC：前へ（左） / 保存（中央） / 次へ（右） */}
      <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center" }}>
        <Box sx={{ width: "120px" }}>
          {canBack ? <BackButton disabled={saving} /> : null}
        </Box>

        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <SaveButton sx={{ ...styles.save, px: 6, py: 1.5, minWidth: "220px" }} />
        </Box>

        <Box sx={{ width: "120px", display: "flex", justifyContent: "flex-end" }}>
          {canNext ? <NextButton disabled={saving} /> : null}
        </Box>
      </Box>
    </Box>
  );
}
